import { Box, Typography } from "@mui/material";
import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTime from "@mui/icons-material/AccessTime";
import "../CSS/Background.css";
import "./Address.css";

export default function Address() {
  // Structured data for SEO (Schema.org/LocalBusiness)
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Your Local Business Name (e.g., Culver City Christmas Trees)",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "11111 Jefferson Blvd.",
      "addressLocality": "Culver City",
      "addressRegion": "CA",
      "postalCode": "90230",
      "addressCountry": "US"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
        ],
        "opens": "10:00",
        "closes": "21:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Saturday",
          "Sunday"
        ],
        "opens": "10:00",
        "closes": "21:00"
      }
    ]
  };

  return (
    <>
      {/* Structured Data JSON-LD */}
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      
      <Box
        component="section" // Use a semantic section tag
        aria-label="Business Location and Hours"
        className="background"
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "stretch",
        }}
      >
        {/*---------Location box start---------*/}
        <Box
          component="article" // Use an article tag for a standalone piece of content
          sx={{
            margin: "16px",
            padding: "8px",
            display: "flex",
            alignItems: "center",
            boxShadow: "10",
            borderRadius: "24px",
            backgroundColor: "secondary.main",
          }}
          itemScope // Start Schema.org item scope for the address
          itemType="https://schema.org/PostalAddress"
        >
          <LocationOnIcon 
            sx={{ fontSize: "50px", color: "text.main" }} 
            aria-hidden="true" 
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "16px",
            }}
          >
            <Typography
              component="h2" // Use an h2 for a main heading in the section
              sx={{ color: "text.main", fontSize: "25px", fontWeight: "bold" }}
            >
              Our Location
            </Typography>
            <Typography 
              component="p" // Use p tag for paragraph content
              sx={{ color: "text.main", fontSize: "25px" }}
              itemProp="streetAddress" // Schema.org property
            >
              11111 Jefferson Blvd.
            </Typography>
            <Typography 
              component="p"
              sx={{ color: "text.main", fontSize: "25px" }}
            >
              <span itemProp="addressLocality">Culver City</span>, 
              <span itemProp="addressRegion"> CA </span> 
              <span itemProp="postalCode">90230</span>
            </Typography>
            <Typography 
              component="p"
              sx={{ color: "text.main", fontSize: "20px" }}
            >
              <span>(Entrance is on Machado Road.)</span>
            </Typography>
          </Box>
        </Box>
        {/*---------Location box end---------*/}
        
        {/*---------Hours box Start---------*/}
        <Box
          component="article"
          sx={{
            margin: "16px",
            padding: "8px",
            display: "flex",
            alignItems: "center",
            boxShadow: "10",
            borderRadius: "24px",
            backgroundColor: "secondary.main",
          }}
          itemScope // Start Schema.org item scope for the hours
          itemType="https://schema.org/OpeningHoursSpecification"
        >
          <AccessTime 
            sx={{ fontSize: "50px", color: "text.main" }} 
            aria-hidden="true" 
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "16px",
            }}
          >
            <Typography
              component="h2"
              sx={{ color: "text.main", fontSize: "25px", fontWeight: "bold" }}
            >
              Lot Hours:
            </Typography>
            <Typography 
              component="p" 
              sx={{ color: "text.main", fontSize: "25px" }}
            >
              <span itemProp="dayOfWeek" content="Monday Tuesday Wednesday Thursday Friday">
                Everyday
              </span>: <time itemProp="opens" content="10:00">10AM</time> – <time itemProp="closes" content="21:00">9PM</time>
            </Typography>
          </Box>
        </Box> 
        {/*---------Hours box End---------*/}
      </Box>
    </>
  );
}